<template>
    <div class="el-time-spinner has-seconds">
        <el-scrollbar
            @mouseenter.native="emitSelectRange('hours')"
            @mousemove.native="adjustCurrentSpinner('hours')"
            class="el-time-spinner__wrapper"
            wrap-style="max-height: inherit;"
            view-class="el-time-spinner__list"
            noresize
            tag="ul"
            ref="hours">
            <li class="el-time-spinner__item" v-for="(hour, index) in 24" :key="index"
                @click="handleClick('hours', { value: index })">
                {{('0' + index).slice(-2)}}
            </li>
        </el-scrollbar>
        <div class="el-time-spinner__wrapper">
            <li class="el-time-spinner__item spinner-top">
                00
            </li>
        </div>
        <div class="el-time-spinner__wrapper">
            <li class="el-time-spinner__item spinner-top">
                00
            </li>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        hours: {
            type: Number,
            default: new Date().getHours()
        }
    },
    data() {
        return {
        };
    },
    methods: {
        modifyDateField(type, value) {
            switch (type) {
            case 'hours': this.$emit('change', { type, value }); break;
            }
        },
        emitSelectRange(type) {
            if (type === 'hours') {
                this.$emit('select-range', 0, 2);
            }
        },
        adjustSpinner(type, value) {
            const el = this.$refs[type].wrap;
            if (el) {
                el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
            }
        },
        handleClick(type, { value }) {
            this.modifyDateField(type, value);
            this.adjustSpinner(type, value);
        },
        bindScrollEvent() {
            const bindFuntion = (type) => {
                this.$refs[type].wrap.onscroll = (e) => {
                    this.handleScroll(type, e);
                };
            };
            bindFuntion('hours');
        },
        handleScroll(type) {
            const value = Math.min(Math.round(
                (this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)),
            (type === 'hours' ? 23 : 59));
            this.modifyDateField(type, value);
        },
        adjustCurrentSpinner(type) {
            this.adjustSpinner(type, this[type]);
        },
        typeItemHeight(type) {
            return this.$refs[type].$el.querySelector('li').offsetHeight;
        },
        scrollBarHeight(type) {
            return this.$refs[type].$el.offsetHeight;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.bindScrollEvent();
        });
    }
};
</script>